import { blueprintsData } from '../blueprints/blueprintsData-sidecar'
import { keyboard } from '../input/keyboard-sidecar'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { ITileDataShip } from '../tiles/tilesDataShip'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { cursors } from '../ui/cursors-sidecar'
import { uiBuild } from '../ui/uiBuild-sidecar'
import { uiDebug } from '../ui/uiDebug-sidecar'
import { uiMode } from '../ui/uiMode-sidecar'
import { uiNewGame } from '../ui/uiNewGame-sidecar'
import { uiStats } from '../ui/uiStats-sidecar'
import { TileSelectorMode } from '../ui/uiTileSelector'
import { uiTileSelector } from '../ui/uiTileSelector-sidecar'
import { uiTravel } from '../ui/uiTravel-sidecar'
import { editorBuild } from './editorBuild-sidecar'
import { editorDecustruct } from './editorDecustruct-sidecar'
import { editorMine } from './editorMine-sidecar'
import { editorTest } from './editorTest-sidecar'

let _mode: TileSelectorMode = 'none'
export const setMode = (mode: TileSelectorMode) => {
  _mode = mode

  uiMode.closeDialogs()
  uiTileSelector.setMode(mode)
  let ctx = scene.getContext()

  if (mode !== 'build') {
    uiBuild.setOpen(false)
  }
  if (mode !== 'debug-spawn') {
    uiDebug.setOpen(false)
  }
  uiStats.setOpen(mode === 'stats')
  uiTravel.setOpen(mode === 'travel')
  uiNewGame.setOpen(mode === 'new-game')

  let isClassic =
    mode === 'structures' || mode === 'floors' || mode === 'shadows'
  uiMode.setOpen(!isClassic, false)

  if (mode === 'mine') {
    cursors.setToBlueprint(
      scene.getContext().cursor,
      blueprintsData.dataMapName['mine'],
    )
  }

  if (mode === 'deconstruct-hull') {
    cursors.setToBlueprint(
      scene.getContext().cursor,
      blueprintsData.dataMapName['deconstruct-hull'],
    )
  }

  if (mode === 'cancel') {
    cursors.setToBlueprint(
      scene.getContext().cursor,
      blueprintsData.dataMapName['cancel'],
    )
  }

  let ll = layers.getLayers()
  ll.gasses.visible = mode === 'o2'
}
export const getMode = () => {
  return _mode
}

export const newMap = () => {
  let floors = tilesDataShip.getFloors()
  let walls = tilesDataShip.getStructures()

  let ctx = scene.getContext()
  let map = ctx.mapShip

  for (let j = 0; j < map.height - 1; j++) {
    for (let i = 0; i < map.width; i++) {
      let t = tileMapShip.getTileUnsafe(map, i, j)
      tilesShip.setFloor(t, floors[0])

      if (i === 0 || j == 0 || i === map.width - 1 || j === map.height - 2) {
        tilesShip.setStructure(t, walls[0])
      }
    }
  }
}

export const update = () => {
  let s = common.getPhaserScene()
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()
  let t = tileMapShip.getTileAtMouse(
    ctx.mapShip,
    s.input.mousePointer.x,
    s.input.mousePointer.y,
  )

  let isGodMode = keyboard.getKeys().godMode

  if (!clickEater.isEaten()) {
    if (t) {
      if (s.input.mousePointer.isDown) {
        let data: ITileDataShip | null = null

        let isLeft = false
        if (clickEater.isPrimaryDownAndUneaten()) {
          data = ctx.cursor.tileData
          isLeft = true
        }

        if (_mode === 'test') {
          editorTest.run(t, isLeft)
        }
        if (_mode === 'o2') {
          editorTest.run(t, isLeft) // Still allow click
        }

        if (_mode === 'deconstruct-hull') {
          editorDecustruct.run(t, isLeft, isGodMode)
        }

        if (_mode === 'mine') {
          editorMine.run(t, isLeft)
        }

        if (_mode === 'build') {
          editorBuild.run(t, isLeft, isGodMode)
        }

        // if (_mode === 'floors') {
        //   if (!data || data.isFloor) {
        //     tilesShip.setFloor(t, data)
        //     mapSaverShip.saveLater()
        //   }
        // } else if (_mode === 'structures') {
        //   if (!data || data.isStructure) {
        //     tilesShip.setStructure(t, data)
        //     mapSaverShip.saveLater()
        //   }
        // } else if (_mode === 'shadows') {
        //   if (!data || data.isShadow) {
        //     tilesShip.setShadow(t, data)
        //     mapSaverShip.saveLater()
        //   }
        // } else if (_mode === 'doors' || _mode === 'objects') {
        //   if (!data || data.isObject || data.isDoor) {
        //     tilesShip.setObject(t, data)
        //     mapSaverShip.saveLater()
        //   }
        // }
      }
    }
  }
}
